/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';

/**
 * Note: this is a short term solution to handle dynamic placement of components based on feature flags.
 * This is not a long term solution and should be replaced with a more robust solution using withConfigService.
 * Story to track this: https://thd.atlassian.net/browse/FUS1-310
 */

/**
 *
 * render: [
 *   {
 *     name: The feature switch name.
 *     value: The expected value to match against.
 *     default: The default slot if the feature switch is not found.
 *   }
 * ],
 *
 */
export function withConfigServiceTNT(BaseComponent, opts = {}) {
  function ConfigServiceTNTRule(props) {
    const {
      renderRules: renderRulesProp = [],
      propRules: propRulesProp = {}
    } = props;

    const configValue = useConfigService(opts?.render?.name);

    const renderRules = [...renderRulesProp];

    const propRules = {
      ...propRulesProp,
    };

    if (opts.render) {
      if (configValue === undefined) {
        renderRules.push(!!opts.render.default);
      } else {
        const matchedValue = configValue === opts.render.value;
        renderRules.push(matchedValue);
      }
    }

    return (
      <BaseComponent
        {...props}
        renderRules={renderRules}
        propRules={propRules}
      />
    );
  }

  ConfigServiceTNTRule.displayName = 'ConfigServiceTNTRule';

  ConfigServiceTNTRule.dataModel = {};

  return ConfigServiceTNTRule;
}
